module.exports = __webpack_public_path__ + "static/media/img19.736f4607.png";